/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The name of a step within a job workflow.
*/
export enum JobStepName {
  JOB_STEP_NAME_CREATE_VM_SNAPSHOT = 'CREATE_VM_SNAPSHOT',
  JOB_STEP_NAME_CREATE_DDB_TABLE = 'CREATE_DDB_TABLE',
  JOB_STEP_NAME_WRITE_DDB_DATA = 'WRITE_DDB_DATA',
  JOB_STEP_NAME_RESTORE_DDB_CONFIG = 'RESTORE_DDB_CONFIG',
  JOB_STEP_NAME_RECREATE_DDB_GSIS = 'RECREATE_DDB_GSIS'
}
